import { Injectable } from '@angular/core';
import { TableColumnService } from '../services/table-column.service';
import { TableColumnProvider } from '../../../interfaces/table-column-provider';
import { TableColumn } from '../../../models/table-column';
import { ShipmentHeader } from '../../../models/shipment-header';
import { DateService } from '../services/date.service';
import { CurrencyService } from '../services/currency.service';
import { ShipmentState } from '../../../utils/shipment-state';
import { EntityEnum } from '../../../enum/entity.enum';

@Injectable({
    providedIn: 'root'
})
export class ShipmentHeaderGeneralService implements TableColumnProvider {

    public readonly SHIPMENT_STATUS = 'SHIPMENT_STATUS';
    public readonly SHIPMENT_DATE = 'SHIPMENT_DATE';
    public readonly TRACKING_NUMBER = 'TRACKING_NUMBER';
    public readonly CUSTOMER_PRICE = 'CUSTOMER_PRICE';
    public readonly COURIER = 'COURIER';

    constructor(private tableColumnService: TableColumnService, private dateService: DateService, private currencyService: CurrencyService) {
        this.tableColumnService.registerProvider(this);
    }

    get(id: string): TableColumn {
        switch (id) {
            case this.COURIER:
                return {
                    id: this.COURIER,
                    caption: $localize`Courier`,
                    width: 100,
                    sort: 'service',
                    render: null,
                    export: (entity: ShipmentHeader) => entity.serviceId
                };
            case this.SHIPMENT_STATUS:
                return {
                    id: this.SHIPMENT_STATUS,
                    caption: $localize`Status`,
                    width: 100,
                    sort: 'status',
                    render: null,
                    export: (entity: ShipmentHeader) => entity.status,
                };
            case this.SHIPMENT_DATE:
                return {
                    id: this.SHIPMENT_DATE,
                    caption: $localize`Date`,
                    width: 100,
                    sort: 'shipmentDate',
                    defaultSortDirection: 'desc',
                    render: (entity: ShipmentHeader) => this.dateService.renderShortDate(entity.shipmentDate)
                };
            case this.TRACKING_NUMBER:
                return {
                    id: this.TRACKING_NUMBER,
                    caption: $localize`Tracking Number`,
                    width: 120,
                    sort: 'trackingNumber',
                    render: (entity: ShipmentHeader) => entity.trackingNumber
                };
            case this.CUSTOMER_PRICE:
                return {
                    id: this.CUSTOMER_PRICE,
                    caption: $localize`Price`,
                    width: 100,
                    sort: 'customerPrice',
                    render: (entity: ShipmentHeader) => entity.customerPrice ? this.currencyService.render(entity.customerPrice, entity.customerCurrency) : '',
                    classes: (entity: ShipmentHeader) => ShipmentState.isSubmitted(entity.status) ? '' : 'quote-price'
                };
        }
        throw new Error(`Unrecognized column "${id}" requested`);
    }

    supports(entityClass: string): boolean {
        return entityClass === EntityEnum.SHIPMENT_HEADER;
    }

    ids(): string[] {
        return [ this.COURIER, this.SHIPMENT_STATUS, this.SHIPMENT_DATE, this.TRACKING_NUMBER, this.CUSTOMER_PRICE ];
    }
}
